import { render, staticRenderFns } from "./ProviderList.vue?vue&type=template&id=424f834b&scoped=true&"
import script from "./ProviderList.vue?vue&type=script&lang=ts&"
export * from "./ProviderList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424f834b",
  null
  
)

export default component.exports